import { CalendarPlanShowcaseConfigGivenOutStatus } from '@yandex-int/k-common';

export type CalendarPlanShowcaseItemsMap = Record<CalendarPlanShowcaseItemId, CalendarPlanShowcaseItem>;

export type CalendarPlanShowcaseItemId = number;

export interface CalendarPlanShowcaseLesson {
    additionalContent: string[];
    backgroundColor?: string;
    canBeGiven: boolean;
    description?: string;
    enabled: boolean;
    from: Date;
    givenOutStatus: CalendarPlanShowcaseConfigGivenOutStatus;
    isLessonBeingGivenNow: boolean;
    id: number;
    image: string;
    name: string;
    nextItemId?: number;
    prevItemId?: number;
    skills: string;
    teacherMark: string;
    theme: CalendarPlanShowcaseLessonTheme;
    to: Date;
}

export function isCalendarPlanShowcaseLesson(item: CalendarPlanShowcaseItem): item is CalendarPlanShowcaseLesson {
    return (item as CalendarPlanShowcaseLesson).name !== undefined;
}

export interface CalendarPlanShowcaseLessonTeaser {
    additionalContent: string[];
    from: Date;
    id: number;
    nextItemId?: number;
    prevItemId?: number;
    theme: CalendarPlanShowcaseLessonTheme;
    to: Date;
}

export type CalendarPlanShowcaseItem = CalendarPlanShowcaseLesson | CalendarPlanShowcaseLessonTeaser;

export interface CalendarPlanShowcaseLessonTheme {
    from: Date;
    name: string;
    to: Date;
}

export interface LessonWithDetails {
    assigned_count: number;
    id: number;
    problems_count: number;
}

export enum CalendarPlanShowcaseCarouselHeaderSize {
    S = 's',
    M = 'm',
}

export enum CalendarPlanShowcaseLessonThemeNameSize {
    S = 's',
    M = 'm',
}
